import React from "react";

const PagePlaceholder = ({
  title,
  description,
  centered = false,
  children,
}) => {
  const shellClassName = centered
    ? "page-shell page-shell--centered"
    : "page-shell";

  return (
    <div className={shellClassName}>
      <div className="page-shell__content">
        <h1 className="page-shell__title">{title}</h1>
        {description ? (
          <p className="page-shell__description">{description}</p>
        ) : null}
        {children}
      </div>
    </div>
  );
};

export default PagePlaceholder;
